import * as React from "react"
import { SelectSeeker } from "ui-seeker/core"

const OPTIONS = [
    { label: '30 days', value: '30' },
    { label: '60 days', value: '60' },
    { label: '90 days', value: '90' },
    { label: '120 days', value: '120' },
]

export default function SelectAlertDaysRanged({...props}) {

    const myProps = {
        placeholder: 'Select no. days', label: 'Days ranged *',
        firstSelect: false, isClearable: false, options: OPTIONS,
        icon: {icon: 'calendar-day'}, isMulti: false,
        ...props
    }

    return <SelectSeeker {...myProps} />
}